import * as React from "react";
const PageDescription = () => /* @__PURE__ */ React.createElement("span", null, "Detection Chains correlate individual security events into multi-stage attack campaigns, connecting isolated alerts into a unified attack sequence.");
export default PageDescription;
